import React from 'react';
import { Form } from 'react-bootstrap';

import './checkbox.css';

const CareMapprCheckbox = ({
  id,
  name,
  label,
  checked,
  onChange,
  disabled,
}) => {
  return (
    <div className="checkbox-container">
      <Form.Check
        type="checkbox"
        checked={checked}
        id={id}
        name={name}
        onChange={onChange}
        disabled={disabled}
      />
      {label && (
        <Form.Label htmlFor={id} className="clickable mb-0 ms-2">
          {label}
        </Form.Label>
      )}
    </div>
  );
};

export default CareMapprCheckbox;
